import React, { useState } from 'react';
import { Layout, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import NavMenu from '../navMenu';
import logo from '../../images/tristardj-logo-color.jpg';
import './header.style.scss';

const Header = props => {
  const [open, setOpen] = useState(false);

  return (
    <Layout.Header style={{ position: 'fixed', zIndex: 1, width: '100%', background: "#FFF" }}>
      <Link to="/" className="logo">
        <img src={logo} alt="TriStar DJ Logo"/>
      </Link>
      <NavMenu/>
      <div className="menu-icon">
        <button onClick={() => setOpen(true)}><MenuOutlined/></button>
      </div>
      <Drawer
        title="Menu"
        placement="right"
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        bodyStyle={{ padding: 0 }}
      >
        <NavMenu isMobile={true} onClose={() => setOpen(false)}/>
      </Drawer>
    </Layout.Header>
  );
};

export default Header;
